var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.5012 13.5947C27.2838 19.0688 21.3996 23.2343 14.3405 23.2343C13.3396 23.2343 12.3407 23.1441 11.3555 22.9729C13.7759 25.0686 17.5233 26.1258 21.3958 25.553L26.579 28.1121C26.6673 28.1554 26.763 28.177 26.8588 28.177C26.9733 28.177 27.0873 28.1461 27.188 28.0849C27.372 27.9725 27.4847 27.7736 27.4847 27.5592V22.8457C29.1015 21.3974 29.9884 19.5711 29.9884 17.6737C29.9884 16.223 29.4645 14.8218 28.5012 13.5947Z",
    fill: "#68D585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1913 0.632812C6.82031 0.632812 0.824219 5.34762 0.824219 11.1431C0.824219 13.3707 1.70326 15.4944 3.37033 17.301V23.5082C3.37033 23.7228 3.48491 23.9212 3.67204 24.0344C3.77453 24.0956 3.89037 24.1265 4.00686 24.1265C4.10425 24.1265 4.20164 24.1048 4.29139 24.0616L10.2302 21.1774C11.5255 21.4933 12.8565 21.6535 14.1913 21.6535C21.5623 21.6535 27.5584 16.9387 27.5584 11.1431C27.5584 5.34762 21.5623 0.632812 14.1913 0.632812Z",
    fill: "#68D585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat33);
export default __webpack_public_path__ + "static/media/chat-33.b044cfc612a2d4d98bd357faff0a21ae.svg";
export { ForwardRef as ReactComponent };